import React from "react";
import { Box, Typography, Button } from "@mui/material";

const ErrorPage = () => {
  const handleRetry = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        backgroundColor: "#f7f7f7",
        textAlign: "center",
      }}
    >
      <Typography variant="h3" fontWeight="bold" mb={2}>
        Unexpected Error
      </Typography>

      <Typography variant="body1" mb={4} maxWidth="600px">
        We're sorry, something went wrong while loading this page. Our team has
        been notified and is working on the issue.
      </Typography>

      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          variant="contained"
          onClick={handleRetry}
          sx={{
            borderRadius: ".875rem",
            textTransform: "capitalize",
            fontSize: "1rem",
            padding: "12px 28px",
            backgroundColor: "#1CEAA0",
            color: "#0A0B09",
            "&:hover": {
              backgroundColor: "#0A0B09",
              color: "#fff",
            },
          }}
        >
          Try Again
        </Button>

        <Button
          variant="outlined"
          onClick={handleGoHome}
          sx={{
            borderRadius: ".875rem",
            textTransform: "capitalize",
            fontSize: "1rem",
            padding: "12px 28px",
            borderColor: "#0A0B09",
            color: "#0A0B09",
            "&:hover": {
              backgroundColor: "#f0f0f0",
              borderColor: "#0A0B09",
            },
          }}
        >
          Go to Homepage
        </Button>
      </Box>
    </Box>
  );
};

export default ErrorPage;
